/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Split_EventInputs */

const en_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const fr_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diviser l'evenement`)
};

const de_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Split Event`)
};

const it_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento diviso`)
};

const ru_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Разделенное событие`)
};

const es_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

const zh_cn2_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分裂事件`)
};

const ja_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分割イベント`)
};

const hi_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विभाजन घटना`)
};

const pt_pt2_shortcut_keys_name_split_event = /** @type {(inputs: Shortcut_Keys_Name_Split_EventInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evento dividido`)
};

/**
* | output |
* | --- |
* | "Split Event" |
*
* @param {Shortcut_Keys_Name_Split_EventInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_split_event = /** @type {((inputs?: Shortcut_Keys_Name_Split_EventInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Split_EventInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_name_split_event(inputs)
	if (locale === "de") return de_shortcut_keys_name_split_event(inputs)
	if (locale === "it") return it_shortcut_keys_name_split_event(inputs)
	if (locale === "ru") return ru_shortcut_keys_name_split_event(inputs)
	if (locale === "es") return es_shortcut_keys_name_split_event(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_name_split_event(inputs)
	if (locale === "ja") return ja_shortcut_keys_name_split_event(inputs)
	if (locale === "hi") return hi_shortcut_keys_name_split_event(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_name_split_event(inputs)
	return en_shortcut_keys_name_split_event(inputs)
});